import { render, staticRenderFns } from "./maintain-order-change-business-user-modal.vue?vue&type=template&id=6b35a34e&"
import script from "./maintain-order-change-business-user-modal.vue?vue&type=script&lang=js&"
export * from "./maintain-order-change-business-user-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports